import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

const ERROR_BANNER_HEIGHT_OFFSET = 88;
const ERROR_BANNER_WIDTH = 480;
export const ErrorBannerContainer = styled(Box).attrs({
  position: 'relative',
  justify: ' center',
  align: ' center',
})`
  z-index: 2; // on top of ModalBodyContainer
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition:
    visibility 0.5s,
    opacity 0.5s linear;
  top: ${ERROR_BANNER_HEIGHT_OFFSET}px;
  cursor: pointer;
`;

export const ErrorBanner = styled(Box).attrs({
  width: `${ERROR_BANNER_WIDTH}px`,
  bg: 'lightDanger',
  py: '10px',
  justify: 'center',
  align: 'center',
})`
  border-radius: 5px;
  color: white;
`;

export const IconTextWrapper = styled(Box).attrs({
  justify: 'center',
  align: 'center',
  mx: '20px',
})``;

export const ErrorText = styled(Text).attrs({})`
  color: white;
`;
